import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { useAppDispatch, useAppSelector } from "store/hooks"
import { setInitialURL } from "store/tempDataSlise"
import SubscriptionPlan from "types/enums/SubscriptionPlan"

import { checkRoleType } from "utils/checkRoleType"

export const RedirectPage = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const initialURL = useAppSelector(state => state.tempData.initialURL)
  const userProfile = useAppSelector(state => state.user.userProfile)
  const userRole = checkRoleType(userProfile?.type)

  useEffect(() => {
    if (!userProfile) {
      navigate("/auth/sign-in")
    }

    if (initialURL) {
      navigate(initialURL)
      dispatch(setInitialURL(undefined))

      return
    }

    if (userProfile?.contractor?.subscription_plan === SubscriptionPlan.BASIC_OCT_2025) {
      navigate("/")
      return
    }

    if (["contractor-manager", "contractor-admin", "contractor-engineer"].includes(userRole || "")) {
      navigate("/dashboard")
    }

    if (userRole === "contractor-technician") {
      navigate("/customers")
    }

    if (userRole === "vendor-admin") {
      navigate("/contractors")
    }

    if (userRole === "warehouse-manager") {
      navigate("/wh-orders")
    }

    if (userRole === "sales-manager") {
      navigate("/contractors")
    }
  }, [])

  return null
}
